module.exports = __webpack_public_path__ + "img/urban.a6647748.svg";